import { useMemo } from 'react'

import RateCol from './RateCol'
import CostCol from './CostCol'
import ReachCol from './ReachCol'
import DatesCol from './DatesCol'
import RegionCol from './RegionCol'
import ReorderCol from './ReorderCol'
import ActionsCol from './ActionsCol'
import LocationCol from './LocationCol'
import CategoryCol from './CategoryCol'
import QuantityCol from './QuantityCol'
import DiscountCol from './DiscountCol'
import AssetTypeCol from './AssetTypeCol'

import { insertIf } from '../../../../../../../helpers/common'

const usePreviewProductColumns = ({
  classes,
  allowEdit,
  handleSortChange,
  hasReachData,
  locationRegion,
  setLocationRegion,
  locationCategory,
  setLocationCategory,
  assetColumn,
  selectedCategory,
  setSelectedCategory,
  formik,
  checkInventory,
  editProductId,
  isAmendment,
  updatingProductIds,
  isAmendProcess,
  currencySymbol,
  allowAutoSave,
  handleDeleteProduct,
  handleEditProduct
}) => {
  return useMemo(() => {
    return [
      ...insertIf(allowEdit, ReorderCol),
      RegionCol({ classes, hasReachData, handleSortChange, locationRegion, setLocationRegion }),
      LocationCol({ classes, handleSortChange }),
      CategoryCol({ classes, hasReachData, handleSortChange, locationCategory, setLocationCategory }),
      AssetTypeCol({ classes, handleSortChange, selectedCategory, setSelectedCategory }),
      ...assetColumn,
      DatesCol({ classes, formik, checkInventory, handleSortChange, editProductId, isAmendment }),
      QuantityCol({ classes, formik, editProductId }),
      ...insertIf(hasReachData, ReachCol({ classes, editProductId, updatingProductIds, isAmendProcess, isAmendment })),
      RateCol({ classes, handleSortChange, currencySymbol }),
      DiscountCol({ classes, formik, editProductId }),
      CostCol({ classes, handleSortChange, editProductId, formik, currencySymbol }),
      ...insertIf(
        allowEdit,
        ActionsCol({ classes, formik, editProductId, allowAutoSave, handleDeleteProduct, handleEditProduct })
      )
    ]
  }, [
    allowEdit,
    classes,
    hasReachData,
    handleSortChange,
    locationRegion,
    setLocationRegion,
    assetColumn,
    locationCategory,
    setLocationCategory,
    selectedCategory,
    setSelectedCategory,
    formik,
    checkInventory,
    editProductId,
    isAmendment,
    updatingProductIds,
    isAmendProcess,
    currencySymbol,
    allowAutoSave,
    handleDeleteProduct,
    handleEditProduct
  ])
}

export default usePreviewProductColumns
